<template lang="html">
  <div class="dashboard">
    <!-- <v-header :name="name" :isDashboard="!child" :onBack="true" @backClick="backToDashboard"></v-header> -->
    <v-header :name="name" isDashboard></v-header>
    <div class="container">
    <!-- <div class="top">
    <ul v-if="show">
     <li v-for="item in listdata"><p>{{item.value}}</p><p>{{item.name}}</p></li>
   </ul>
    </div> -->
  <div class="center">
    <!-- <div><v-bars :regionBar="regionBar" v-if="show"></v-bars></div>
    <div><v-twoWayBar :productBar="productBar" v-if="show"></v-twoWayBar></div> -->
        <div><v-pie1 /></div>
        <div><v-pie2 ></v-pie2></div>
    <div><v-pie ></v-pie></div>
    </div>
    <div class="bottom">
      <div><v-table :povertyAlleviaList="povertyAlleviaList" ></v-table></div>
    </div>
<!-- <div class="swiper-button-prev"  @click="prev"></div>
      <div class="swiper-button-next" @click="next"></div> -->
    </div>
  </div>
    
</template>

<script>
import header from 'components/common/headers'
import table from './components/table'
import bars from './components/bars'
import twoWayBar from './components/twoWayBar'
import pie from './components/pie'
import pie1 from './components/pie1'
import pie2 from './components/pie2'
export default {
  data() {
    return {
      name: '农畜产品质量安全大数据中心',
      listdata: [],
      regionBar: [],
      productBar: [],
      distributedBar: [],
      povertyAlleviaList: [],
      timerHelper: null,
      show: false
    }
  },
  async mounted() {
    let { err, res } = await this.$model('dataManagement').commonfn2(this.$apiUrl.DATAANALYSIS.Helper);
    if (res.state === 200) {
      let resultData = JSON.parse(res.results)
      var list = {
        povertyNumber: '脱贫家庭数',
        povertyAlleviation: '扶贫人数',
        perIncome: '贫困户人均收入',
        totalAmount: '帮扶总额'
      }
      for (var key in list) {
        this.listdata.push({ name: list[key], value: resultData[key] })
      }
      this.regionBar = resultData.regionBar
      this.productBar = resultData.productBar
      this.distributedBar = resultData.distributedBar
      this.povertyAlleviaList = resultData.povertyAlleviaList
      console.log(this.povertyAlleviaList)
      this.show = true
    } else {
      this.$message.showError(err);
    }
    // this.timerHelper = setTimeout(() => {
    //   console.log("timerHelper")
    //   this.next()
    // }, 15000);
  },
  beforeDestroy() {
    clearInterval(this.timerHelper);
    this.timerHelper = null;
  },
  methods: {
    clickChild(bool) {
      this.child = bool;
    },
    backToDashboard() {
      this.child = false;
    },
    next() {
      this.$router.push('/rundadashboard');
    },
    prev() {
      this.$router.push('/rundasalesDataCenter');
    }
  },
  components: {
    'v-header': header,
    'v-table': table,
    'v-bars': bars,
    'v-twoWayBar': twoWayBar,
    'v-pie': pie,
    'v-pie1': pie1,
    'v-pie2': pie2
  }
}

</script>

<style lang="stylus" scoped>
html, body {
  width: 100%;
  height: 100%;
  background-color: #060606;
}

.item {
  margin-bottom: 15px;
}

.item2 {
  height: 300px;
}

.dashboard {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background-size: 100% 100%;
}

.container {
  width: 1854px;
  height: 100%;
  margin: 0 auto;

  .top {
    width: 1854px;
    height: 186px;
    background: url('../../../assets/img/helpPoor/top.png');
    background-size: 100% 100%;

    ul {
      height: 120px;
      padding-top: 33px;

      li {
        width: 25%;
        float: left;
        text-align: center;
        color: white;

        // border: 1px red solid;
        p:nth-child(1) {
          padding-top: 15px;
          height: 40px;
          font-size: 40px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(235, 112, 68, 1);
        }

        p:nth-child(2) {
          padding-top: 35px;
          height: 18px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(71, 234, 243, 1);
        }
      }

      li:nth-child(2) {
        margin-left: -30px;

        p:nth-child(1) {
          color: #7299FF;
        }
      }

      li:nth-child(3) {
        margin-left: -12px;

        p:nth-child(1) {
          color: #FFB52B;
        }
      }

      li:nth-child(4) {
        margin-left: -14px;

        p:nth-child(1) {
          color: #FFB52B;
        }
      }
    }
  }

  .center {
    width: 1854px;
    margin-top: 10px;
    height: 250px;
    display: flex;

    div {
      padding: 20px 8px;
      width: 100%;
    }
  }

  .bottom {
    margin-top: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?6afb249e